/**
 * @fileoverview GET handler for the "/apps/:app_group_id/message_archiving_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsMessageArchivingSettings } from "./constants";
import type { GetMessageArchivingSettingsResponse } from "./types";

export const getMessageArchivingSettingsApiEndpoint = reactQueryFetcherAdapter(
  appsMessageArchivingSettings,
  (signal: AbortSignal, appGroupId: string): Promise<GetMessageArchivingSettingsResponse> => {
    return fetch(`/apps/${appGroupId}/message_archiving_settings`, "GET", {}, { signal });
  }
);
